<template>
  <el-row class="core_three_wrap">
    <el-col class="three_left">
      <div class="left_tit">
        学术资源管理、成果转化追踪、专家库建设于一体的综合性平台，旨在实现科研数据的高效整合与价值释放
      </div>
      <div class="left_desc">
        <div class="desc_item">
          <div class="item_left">
            <img src="@/assets/xiazai.png" alt="">
          </div>
          <div class="item_right">
            <p>学术资源全流程管理</p>
            <p>论文与成果登记 动态追踪 数据校验</p>
          </div>
        </div>
        <div class="desc_item">
          <div class="item_left">
            <img src="@/assets/img/xiazai2.png" alt="">
          </div>
          <div class="item_right">
            <p>专家库与协同网络构建</p>
            <p>专家画像 跨学科协作 促进学者与政府、企业的双向流动</p>
          </div>
        </div>
        <div class="desc_item">
          <div class="item_left">
            <img src="@/assets/img/xiazai3.png" alt="">
          </div>
          <div class="item_right">
            <p>成果转化与政策对接</p>
            <p>供需匹配 转化路径优化 政策通道建设</p>
          </div>
        </div>
        <div class="desc_item">
          <div class="item_left">
            <img src="@/assets/img/xiazai4.png" alt="">
          </div>
          <div class="item_right">
            <p>数据驱动的决策支持</p>
            <p>可视化分析 学科评估 校企合作</p>
          </div>
        </div>
      </div>
    </el-col>
    <el-col class="three_right">
      <img src="@/assets/img/right3 (1).png" alt="" />
    </el-col>
  </el-row>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.core_three_wrap {
  display: flex;
  justify-content: center;
  text-align: left;
  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
  }
  .three_left {
    width: 40%;
    @media screen and (max-width: 768px) {
      width: 90%;
    }
    .left_tit{
      color: #3e3e3e;
      font-size: 20px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        margin-top: 20PX;
      }
    }
    .left_desc{
      .desc_item{
        margin-top: 40px;
        display: flex;
        align-items: center;
        padding-left: 50px;
        .item_left{
          img{
            width: 50px;
            height: 50px;
          }
        }
        .item_right{
          margin-left: 20px;
          p{
            margin: 0;
            &:nth-child(1){
              color: #717171;
              font-size: 16px;
              font-weight: bold;
              @media screen and (max-width: 768px) {
                font-size: 1rem;
                margin-top: 20PX;
              }
            }
            &:nth-child(2){
              color: #717171;
              font-size: 14px;
              padding: 6px 0;
              @media screen and (max-width: 768px) {
                font-size: 0.8rem;
              }
            }
          }
        }
      }
    }
  }
  .three_right {
    width: 20%;
    height: 100%;
    margin-left: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 768px) {
      width: 100%;
      margin-top: 20PX;
    }
    img {
      width: 80%;
      margin-top: 40px;
    }
  }
}
</style>
